module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Lampenberg-f80b16aa446b10f5df61426e666f1fe6.svg";